module.exports = __webpack_public_path__ + "static/media/photo257.15a90453.jpg";